/** Strip oklch() colour values from a cloned document before html2canvas capture.
 *  html2canvas cannot parse oklch() (Tailwind v4 default).
 *  Handles one level of nested parens, e.g. oklch(... / calc(...)). */
export async function sanitizeOklch(clonedDoc: Document): Promise<void> {
  const OKLCH_RE = /oklch\((?:[^)(]|\([^)]*\))*\)/g

  for (const styleEl of Array.from(clonedDoc.querySelectorAll('style'))) {
    if (styleEl.textContent?.includes('oklch')) {
      styleEl.textContent = styleEl.textContent.replace(OKLCH_RE, 'transparent')
    }
  }

  // In production builds Vite emits <link rel="stylesheet"> files — fetch,
  // strip oklch, and replace each link with an inline <style>.
  const linkEls = Array.from(
    clonedDoc.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]'),
  )
  await Promise.all(
    linkEls.map(async (linkEl) => {
      try {
        const resp = await fetch(linkEl.href)
        let css = await resp.text()
        if (css.includes('oklch')) {
          css = css.replace(OKLCH_RE, 'transparent')
        }
        const inlined = clonedDoc.createElement('style')
        inlined.textContent = css
        linkEl.replaceWith(inlined)
      } catch {
        // ignore — leave the link in place
      }
    }),
  )
}
